import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { subirDocLegal, clearErrors, getDocsLegal } from '../../../redux/actions/dataactions';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';

import { useDropzone } from 'react-dropzone';
import { FaArrowLeft, FaPlus, FaUpload, FaCheck, FaCheckCircle } from 'react-icons/fa';

import './DocumentoSubir.css';
import { Typography } from '@mui/material';

// Componente funcional Dropzone
const FileDropzone = ({ onFileDrop }) => {
  const { getRootProps, getInputProps, acceptedFiles, fileRejections } = useDropzone({
    accept: { 'application/pdf': ['.pdf'] },
    maxFiles: 1,
    onDrop: onFileDrop
  });

  return (
    <div className="documento-subir-dropzone-container">
      <div {...getRootProps({ className: 'documento-subir-dropzone' })}>
        <input {...getInputProps()} />
        <p className="documento-subir-text">Arrastra y suelta el archivo aquí, o haz clic para seleccionarlo</p>
        <em className="documento-subir-info">(Solo se permite subir un archivo PDF)</em>
      </div>

      <aside className="documento-subir-preview">
        {fileRejections.length > 0 && (
          <div className="documento-subir-file-error">
            <h4>Solo se puede cargar un archivo PDF</h4>
          </div>
        )}
        {acceptedFiles.length > 0 && (
          <div className="documento-subir-file-accepted">
            <h4>Archivo a cargar:</h4>
            <ul className="documento-subir-file-list">
              {acceptedFiles.map(file => (
                <li key={file.path} className="documento-subir-file-item">
                  {file.path} - {file.size} bytes
                </li>
              ))}
            </ul>
          </div>
        )}
      </aside>
    </div>
  );
};

export class DocumentoSubir extends Component {
  state = {
    selectedFile: null,
    open: false,
    errors: {},
    aprobado: {}
  };

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    if (props.UI?.errors) newState.errors = props.UI.errors;
    if (props.UI?.aprobado) newState.aprobado = props.UI.aprobado;
    return Object.keys(newState).length ? newState : null;
  }

  handleOpen = () => {
    this.setState({ open: true, selectedFile: null, aprobado: {}, errors: {} });
  };

  handleClose = () => {
    const { aprobado } = this.state;
    this.props.clearErrors();
    if (aprobado?.mensaje) {
      this.setState({ open: false, selectedFile: null, aprobado: {}, errors: {} });
      this.props.getDocsLegal(this.props.clienteId);
    } else {
      this.setState({ open: false, selectedFile: null, errors: {} });
    }
  };

  handleFileDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      this.setState({ selectedFile: acceptedFiles[0] });
    }
  };

  onFileUpload = () => {
    const { selectedFile } = this.state;
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append('documento', selectedFile, selectedFile.name);

    this.props.subirDocLegal(formData, this.props.docId, this.props.clienteId);
  };

  render() {
    const { UI } = this.props;
    const { loading } = UI;
    const { open, aprobado, errors, selectedFile } = this.state;

    return (
      <Fragment>
        <Tooltip title="Subir Archivo">
          <IconButton onClick={this.handleOpen}>
            <FaUpload color="#03178C" className="documento-subir-btn-icon" />
          </IconButton>
        </Tooltip>

        <Dialog open={open} onClose={this.handleClose} fullWidth maxWidth="sm">
          <DialogTitle><Typography sx={{ 
                                  fontSize: '20px', 
                                  fontWeight: 400, 
                                  color: '#0468BF', 
                                  textAlign: 'start' 
                                  }}>
                                  Subir Documento
                  </Typography></DialogTitle>

          <DialogContent>
            {aprobado?.mensaje ? (
              <div className='documento-subir-aprobado'>
                <div className='documento-subir-icono-container'>
                  <FaCheck color="#ffffff" className='documento-subir-icono' />
                </div>
                <h2 className='documento-subir-texto'>¡Documento Subido Exitosamente!</h2>
              </div>
            ) : (
              <>
                <FileDropzone onFileDrop={this.handleFileDrop} />
                {errors?.error && (
                  <div className="documento-subir-error-container">
                    <p className="documento-subir-error-message">{errors.error}</p>
                  </div>
                )}
              </>
            )}
          </DialogContent>

          <DialogActions>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleClose}>
                <FaArrowLeft color="#D3D7DC" className="documento-subir-form-icon" />
              </IconButton>
            </Tooltip>

            {loading ? (
              <CircularProgress size={30} color="#03178C" />
            ) : aprobado?.mensaje ? (
              <Tooltip title="Continuar">
                <IconButton onClick={this.handleClose}>
                  <FaCheckCircle color="#20B90C" className="documento-subir-form-icon" />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Subir Archivo">
                <span>
                  <IconButton
                    onClick={this.onFileUpload}
                    disabled={!selectedFile}
                  >
                    <FaPlus color="#03178C" className="documento-subir-form-icon" />
                  </IconButton>
                </span>
              </Tooltip>
            )}
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

DocumentoSubir.propTypes = {
  subirDocLegal: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  getDocsLegal: PropTypes.func.isRequired,
  docId: PropTypes.string.isRequired,
  clienteId: PropTypes.string.isRequired,
  UI: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  UI: state.UI
});

export default connect(mapStateToProps, { subirDocLegal, clearErrors, getDocsLegal })(DocumentoSubir);
